// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { CartsDataViewContext } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { Typography } from "@insite/mobius/index";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import myAccountFilterSectionStyles from "@werner/App/SharedStyle/MyAccount/List/MyAccountFilterSectionStyles";
import { pluralize } from "@werner/XDL/Utilities";
import React from "react";
import { useContext } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface SavedOrderListResultsCountStyles {
    wrapper?: InjectableCss;
    savedOrdersCountText?: TypographyPresentationProps;
}

const savedOrderListResultsCountStyles: SavedOrderListResultsCountStyles = {
    wrapper: {
        css: css`
            display: flex;
            margin-bottom: 4px;
        `,
    },
    savedOrdersCountText: {
        ...myAccountFilterSectionStyles.resultCountTextStyles,
    },
};
const styles = savedOrderListResultsCountStyles;

const SavedOrderListResultsCount = (props: Props) => {
    const savedOrderListDataView = useContext(CartsDataViewContext);
    const savedOrderCount =
        savedOrderListDataView.value && savedOrderListDataView.pagination
            ? savedOrderListDataView.pagination.totalItemCount
            : 0;

    if (savedOrderCount === 0) {
        return null;
    }
    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.savedOrdersCountText}>
                {`${savedOrderCount} ${translate(pluralize(savedOrderCount, "Saved Order"))}`}
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SavedOrderListResultsCount,
    definition: {
        group: "Saved Order List",
        displayName: "Saved Order List Results Count",
        allowedContexts: ["SavedOrderListPage"],
    },
};

export default widgetModule;
